import BaseModel from './base'


export const schema = {
  id: undefined,
  name: '',
  tags_cuisine_list: '',
  image: undefined,
  chef: undefined,
  main_menu_items: [],
}


export default class MarketplacePage extends BaseModel( schema ) {
  static create( json = {}) {
    return new MarketplacePage( json )
  }
}
